import { ID } from "common/entities/IEntity";
import { Field } from "typegraph";

export default class IdName {
	@Field()
	public id: ID;

	@Field()
	public name: string;
}



// WEBPACK FOOTER //
// ./src/core/util/IdName.ts